import {DiscountData} from "@/types";
import {GetterTree} from "vuex";
import { DiscountState, RootState } from "@/types/store/adminzone";

export const getters: GetterTree<DiscountState, RootState> = {
  GET_DISCOUNTS: (state): Array<DiscountData> => state.discounts,
  GET_DISCOUNTS_TOTAL_COUNT: (state) => state.discountsTotalCount
 }
